import React from 'react';
import { StyleUtil } from 'ui/util';
import { useConfigContext } from '../../config';
import { KalturaPlayer, KalturaPlayerEmbedParams } from '../../KalturaPlayer';
import { CaseTabContentContainer } from '../case-tab-content-container';
import classNames from './EABD2CaseOverviewTabContent.module.scss';

type CaseOverviewTabAssetType = 'case1' | 'case2' | 'case3';

export interface CaseOverviewTabContentProps
  extends Readonly<{
    title: string;
    description: string;
    assetType: CaseOverviewTabAssetType;
  }> {}

export const CaseOverviewTabContent = React.memo<CaseOverviewTabContentProps>((props) => {
  const { title, description, assetType } = props;

  const { getKalturaCase1VideoEmbedParams, getKalturaCase2VideoEmbedParams, getKalturaCase3VideoEmbedParams } = useConfigContext();

  const KalturaPlayerEmbedParamsMemo = React.useMemo<KalturaPlayerEmbedParams>(() => {
    switch (assetType) {
      case 'case1':
        return getKalturaCase1VideoEmbedParams();
      case 'case2':
        return getKalturaCase2VideoEmbedParams();
      case 'case3':
        return getKalturaCase3VideoEmbedParams();
      default:
        throw new Error('CaseOverviewTabContent: unknown asset type!');
    }
  }, [assetType, getKalturaCase1VideoEmbedParams, getKalturaCase2VideoEmbedParams, getKalturaCase3VideoEmbedParams]);

  React.useEffect(() => {
    KalturaPlayer.embedPlayer(KalturaPlayerEmbedParamsMemo);

    return () => {
      KalturaPlayer.destroyPlayer(KalturaPlayerEmbedParamsMemo.targetId);
    };
  }, [KalturaPlayerEmbedParamsMemo]);

  const AssetWrapperClassNames = React.useMemo<string>(() => {
    const wrapperClassNames = StyleUtil.createInitialClassNameArray(classNames.assetWrapper);

    switch (assetType) {
      case 'case1':
        wrapperClassNames.push(classNames.asset1);
        break;
      case 'case2':
        wrapperClassNames.push(classNames.asset2);
        break;
      case 'case3':
        wrapperClassNames.push(classNames.asset3);
        break;
      default:
        throw new Error('CaseOverviewTabContent: unknown asset type!');
    }

    return StyleUtil.mergeClassNames(wrapperClassNames);
  }, [assetType]);

  return (
    <CaseTabContentContainer>
      <div className={classNames.textWrapper}>
        <div className={classNames.titleWrapper}>
          <p className={classNames.title}>{title}</p>
        </div>
        <p className={classNames.description}>{description}</p>
      </div>
      <div id={KalturaPlayerEmbedParamsMemo.targetId} className={AssetWrapperClassNames} />
    </CaseTabContentContainer>
  );
});
